<style lang="scss" scoped>
.footer-button {
    margin: 0 5px;
}
.modal-desc {
    padding: 20px 0;
    text-align: center;
    font-size: 14px;
}
.modal-button {
    float: right;
}
</style>
<template>
    <div>
        <compWrapper theme="primary" title="基础信息">
            <compFormEdit
                v-if="queryType !== 'query'"
                class="margin-layout"
                ref="formbase"
                :formdata="getBase"
                v-model="formData"
                placeholder="--"
                :col="2"
            ></compFormEdit>
            <compFormQuery
                v-else
                class="margin-layout"
                :formdata="getBase"
                :value="formData"
                placeholder="--"
                :col="2"
            ></compFormQuery>
            <slot name="footer" slot="footer">
                <Button
                    v-if="queryType !== 'query'"
                    class="footer-button margin-right-15"
                    type="primary"
                    @click="save"
                    >保存</Button
                >
                <Button
                    v-if="formData.status === 0"
                    class="footer-button margin-right-15"
                    type="success"
                    @click="handleOperate(5)"
                    >确认</Button
                >
                <Button
                    v-if="queryType === 'query' && formData.status === 0"
                    class="footer-button margin-right-15"
                    type="error"
                    @click="handleOperate(10)"
                    >取消</Button
                >
                <Button class="footer-button" @click="cancel">返回</Button>
            </slot>
        </compWrapper>
        <compWrapper theme="info" title="销毁明细">
            <Form
                v-if="queryType !== 'query'"
                class="clearfix margin-top-15"
                :model="detailData"
                :labelWidth="110"
                ref="detailForm"
            >
                <Col span="6">
                    <FormItem label="SKU" prop="item" :rules="required">
                        <Select
                            v-model="detailData.item"
                            @on-change="changeSku"
                        >
                            <Option
                                v-for="item in skuList"
                                :key="item.key"
                                :value="item"
                                >{{ item.sku }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem label="待销毁数量">
                        <div class="font-weight">{{ detailData.num }}</div>
                    </FormItem>
                </Col>
                <Col span="6">
                    <FormItem
                        label="销毁数量"
                        prop="destoryNum"
                        :rules="required"
                    >
                        <Input v-model="detailData.destoryNum"></Input>
                    </FormItem>
                </Col>
                <Col span="6">
                    <Button
                        class="margin-left-40"
                        type="primary"
                        @click="addSku"
                        >添加</Button
                    >
                    <Button
                        class="margin-left-10"
                        type="info"
                        @click="importFile"
                        >导入</Button
                    >
                    <Button
                        class="margin-left-10"
                        type="success"
                        @click="fastAdd"
                        >一键添加</Button
                    >
                </Col>
            </Form>
            <div class="table-content">
                <div v-if="queryType !== 'query'" class="button-area">
                    <Button
                        class="margin-left-40"
                        type="default"
                        @click="delItems"
                        >删除</Button
                    >
                    <Button
                        class="margin-left-10"
                        type="default"
                        @click="fastClear"
                        >清空</Button
                    >
                </div>
                <compTableList
                    style="margin: 15px"
                    :columns="destoryColumn"
                    v-bind="getTableListProps"
                    ref="tableList"
                    @on-select="handleSelection"
                ></compTableList>
            </div>
        </compWrapper>
        <compWrapper v-if="queryType === 'query'" theme="gray" title="操作历史">
            <compLog
                class="margin-layout"
                :data="logList"
                :columns="logcolumn"
            ></compLog>
        </compWrapper>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="modalProps.show = false"
            @on-confirm="modalProps.show = false"
        >
            <div class="clearfix" v-if="modalProps.showConfirm">
                <div class="modal-desc">{{ modalProps.desc }}</div>
                <div class="modal-button">
                    <Button
                        class="margin-right-10"
                        type="primary"
                        @click="modalProps.confirm"
                        >确定</Button
                    >
                    <Button type="default" @click="modalProps.show = false"
                        >取消</Button
                    >
                </div>
            </div>
            <component
                v-if="modalProps.component"
                :is="modalProps.component"
                v-bind="modalProps.props"
                @on-close="modalProps.show = false"
                @on-success="modalSuccess"
                v-on="modalProps.on"
            />
        </compModal>
        <Spin v-if="loading" fix size="large"></Spin>
    </div>
</template>

<script>
import mixin from "./mixin";
import compSubmit from "./../submit";
import {
    HttpUpdateDestoryOrder,
    HttpGetDestoryPlanProductList,
    HttpGetOrderById,
    HttpGetDestoryDetail,
    HttpGetDestoryLog,
    HttpDestoryOrderDetailAdd,
    HttpDesotryOrderDetailDel,
    HttpDesotryOrderSave,
    HttpDestoryOrderFastAdd,
    HttpDestoryOrderFastClear,
    HttpDestoryOrderGetDestoryQty,
} from "@/service/destory";
export default {
    props: ["type", "id"],
    mixins: [mixin],
    components: {
        compTableList: () => import("@components/templates/tablelist"),
        compSubmit,
    },
    data() {
        return {
            queryType: this.type ? this.type : this.$route.params.type,
            orderId: this.id ? this.id : this.$route.query.id,
            formData: {},
            detailData: {},
            skuList: [],
            destoryList: [],
            logList: [],
            required: {
                required: true,
                message: "请填写必填项",
            },
            modalProps: {
                show: false,
                formdata: null,
            },
            startUp: 0,
            loading: false,
        };
    },
    created() {
        console.log(this.queryType, this.orderId);
        this.update();
    },
    methods: {
        importFile() {
            this.modalProps = {
                show: true,
                title: "导入",
                component: "compMutiUpload",
                showFooter: false,
                width: 600,
                props: {
                    ...this.getFileProps,
                },
                on: {
                    "on-cancel": () => {
                        this.modalProps.show = false;
                    },
                    "on-success": (list) => {
                        // alert(1)
                        console.log(list);
                        this.modalProps.show = false;
                        this.startUp++;
                    },
                },
            };
        },
        /**
         * 一键添加
         */
        fastAdd() {
            console.log(this.orderId);
            HttpDestoryOrderFastAdd({
                destroyOrderId: this.orderId,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.startUp++;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        /**
         * 清空
         */
        fastClear() {
            this.modalProps = {
                show: true,
                showConfirm: true,
                title: "清空",
                desc: "确定清空？",
                showFooter: false,
                confirm: () => {
                    HttpDestoryOrderFastClear({
                        destroyOrderId: this.orderId,
                    }).then(
                        (res) => {
                            this.$VMessage.success(res.message);
                            this.startUp++;
                            this.modalProps.show = false;
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    );
                },
            };
        },
        /**
         * 销毁明细删除
         */
        delItems() {
            const checkedData = this.$refs.tableList.checkedData;
            if (!checkedData.length)
                return this.$VMessage.warning("请至少选择一项");
            HttpDesotryOrderDetailDel({
                ids: checkedData.join(","),
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.startUp++;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        /**
         * 选择sku
         */
        async changeSku() {
            // this.detailData.num =
            //     this.detailData.item.planQty - this.detailData.item.destroyQty;
            await HttpDestoryOrderGetDestoryQty({
                destroyPlanOrderId: this.detailData.item.destroyPlanOrderId,
                sku: this.detailData.item.sku,
            }).then(
                (res) => {
                    console.log(res.data);
                    this.$set(this.detailData, "num", res.data);
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        /**
         * 销毁明细增加
         */
        async addSku() {
            let flag = true;
            this.$refs.detailForm.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            let { destroyPlanOrderId, sku } = { ...this.detailData.item };
            // console.log(this.detailData)
            await HttpDestoryOrderDetailAdd({
                destroyPlanOrderId,
                sku,
                destroyOrderId: this.orderId,
                destroyQty: this.detailData.destoryNum,
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.$refs.detailForm.resetFields();
                    this.startUp++;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        /**
         * 获取销毁单详情
         */
        async update() {
            this.loading = true;
            // 基础信息
            await HttpGetOrderById({
                id: this.orderId,
            }).then(
                (res) => {
                    console.log(res);
                    this.formData = {
                        ...res.data,
                    };
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.startUp += 1;
            if (this.queryType === "query") {
                await HttpGetDestoryLog({
                    page: 1,
                    rows: 1000,
                    sidx: "id",
                    sord: "desc",
                    "search[EQ_orderNo]": this.formData.destroyOrderNo,
                    "search[EQ_orderType]": 6001,
                }).then(
                    (res) => {
                        this.logList = res.data.content;
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            } else {
                await HttpGetDestoryPlanProductList({
                    destroyPlanOrderId: this.formData.destroyPlanOrderId,
                }).then(
                    (res) => {
                        console.log("list", res);
                        this.skuList = res.data;
                    },
                    (err) => {
                        this.$VMessage.error(err);
                    }
                );
            }
            this.loading = false;
        },
        /**
         * 取消成功后
         */
        modalSuccess() {
            this.update();
        },
        /**
         * 销毁单保存
         */
        async save(success) {
            let flag = true;
            this.$refs.formbase.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            this.loading = true;
            await HttpDesotryOrderSave({
                ...this.formData,
            }).then(
                (res) => {
                    if (
                        Object.prototype.toString.call(success) ===
                        "[object Function]"
                    ) {
                        success();
                    } else {
                        this.$VMessage.success(res.message);
                        this.$router.push({
                            name: "destoryOrder",
                        });
                    }
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
        /**
         * 返回
         */
        cancel() {
            if (this.$route.name === "destoryOrder") {
                this.$emit("on-close");
            } else {
                this.$router.push({
                    name: "destoryOrder",
                });
            }
        },
        /**
         * 处理按钮操作
         */
        handleOperate(type) {
            let operate =
                this.operateTypeList.filter((item) => {
                    return item.value === type;
                })[0] || {};
            if (!operate) return;
            operate = operate.label;
            // 确认
            if (type === 5) {
                if (this.queryType === "query") {
                    this.modalShow(operate, type, this.cancel);
                }
                // 新增|编辑
                else {
                    this.save(async () => {
                        await this.modalShow(operate, type, this.cancel);
                    });
                }
            } else {
                this.modalShow(operate, type, this.cancel);
            }
        },
        modalShow(title, type, success) {
            this.modalProps = {
                show: true,
                title: title,
                showFooter: false,
                width: 600,
                props: {
                    otherParams: {
                        noRequired: true,
                    },
                    id: this.orderId,
                    type: type,
                    isOrder: 1,
                    success: success,
                },
                component: "compSubmit",
                "on-cancel": () => {
                    this.modalProps.show = false;
                },
                "on-success": () => {
                    this.$emit("on-update");
                },
            };
        },
    },
    computed: {
        getFileProps() {
            return {
                action:
                    process.env.VUE_APP_APIURL_FBB +
                    "/api/v2/destroyOrderItem/importItems",
                name: "excelFile",
                // data: {
                // 	attachType: this.formData.attachType,
                //     orderId: this.id ? this.id : '',
                //     orderType: 6000
                // },
                // accept: this.formData.accept,
                data: {
                    destroyOrderId: this.orderId,
                },
                multiple: false,
                download() {
                    this.handleWebfs("/static/template/destory_order.xlsx", {}, {
                        executor: 'download',
                        type: 'url'
                    });
                },
                formatter: (res, item) => {
                    return res.data
                }
                // format: this.formData.format
            };
        },
        getBase() {
            return [
                {
                    label: "销毁单号",
                    key: "destroyOrderNo",
                    query: true,
                },
                {
                    label: "状态",
                    key: "status",
                    query: true,
                    tag: "vSelect",
                    options: this.statusList,
                },
                {
                    label: "销毁计划单号",
                    key: "destroyPlanOrderNo",
                    query: true,
                },
                {
                    label: "来源单号",
                    key: "sourceNo",
                    query: this.queryType === "query",
                    required: false,
                },
                {
                    label: "销毁仓库",
                    key: "orgWarehouseName",
                    query: true,
                },
                {
                    label: "项目",
                    key: "lineName",
                    query: true,
                },
                {
                    label: "备注",
                    key: "remark",
                    required: false,
                    query: this.queryType === "query",
                },
            ];
        },
        destoryColumn() {
            let result = [
                {
                    type: "index",
                    title: "No.",
                    width: 60,
                    align: "center",
                },
                {
                    title: "SKU",
                    key: "sku",
                },
                {
                    title: "销毁数量",
                    key: "destroyQty",
                },
                {
                    title: "更新时间",
                    key: "updatedAt",
                },
            ];
            if (this.queryType !== "query") {
                result.unshift({
                    type: "selection",
                    formName: "id",
                    width: 60,
                    align: "center",
                });
            }
            return result;
        },
        getTableListProps() {
            return {
                ajaxRequest: HttpGetDestoryDetail,
                interceptRequest: (params) => {
                    return {
                        ...params,
                        search: {
                            EQ_destroyOrderId: this.orderId,
                        },
                    };
                },
                startUp: this.startUp,
                on: {
                    "on-select": (a) => {
                        console.log(a);
                    },
                },
            };
        },
        logcolumn() {
            return [
                {
                    type: "index",
                    title: "No.",
                    width: 60,
                    align: "center",
                },
                {
                    title: "操作类型",
                    width: 100,
                    render: (h, { row }) => {
                        let label = this.operateTypeList.filter((item) => {
                            return item.value === row.operateType;
                        })[0].label;
                        return <div>{label}</div>;
                    },
                },
                {
                    title: "操作人",
                    key: "updatedName",
                    width: 100,
                },
                {
                    title: "备注",
                    key: "remark",
                },
                {
                    title: "操作时间",
                    key: "updatedAt",
                    width: 200,
                },
            ];
        },
    },
};
</script>